import { useMutation, useQueryClient } from "react-query"
import { useNavigate } from "react-router-dom"
import { toast } from "react-toastify"
import { PageTitle } from "../../../_metronic/layout/core"
import { saveSetting } from "../../models/settings"
import Authorization from "../../routing/Authorization"
import SettingForm from "./components/SettingForm/SettingForm"

const breadcumbs = [
    {
        title: 'Settings',
        path: '/settings/website',
        isSeparator: false,
        isActive: false,
    },
    {
        title: '',
        path: '',
        isSeparator: true,
        isActive: false,
    },
]

const CreateWebsiteSetting = () => {
    const navigate = useNavigate()

    const queryClient = useQueryClient()
    const { mutate, isLoading: isSubmitLoading } = useMutation(data => saveSetting(data), {
        onSuccess: () => {
            queryClient.invalidateQueries(['settings'])
            toast.success('Success')
            navigate('/settings/website')
        },
        onError: error => toast.error(error?.response?.data?.message)
    })

    const onSubmit = values => {
        const data = new FormData()
        data.append('key', values.key)
        data.append('value', values.value)
        mutate(data)
    }

    return (
        <>
            <PageTitle breadcrumbs={breadcumbs}>Create Setting</PageTitle>
            <div className="card">
                <div className="card-body">
                    <SettingForm
                        queryClient={queryClient}
                        onSubmit={onSubmit}
                        isSubmitLoading={isSubmitLoading}
                    />
                </div>
            </div>
        </>
    )
}

export default Authorization(CreateWebsiteSetting, ['admin', 'officer'])